const log = globalThis.console?.log?.bind(globalThis.console);

// Render a styled console banner to make it easy to identify the running build.
export const logBuildBanner = () => {
  if (!log) return;

  const stage =
    import.meta.env.VITE_STAGE ??
    import.meta.env.VITE_APP_STAGE ??
    import.meta.env.MODE ??
    "unknown";

  const region =
    import.meta.env.VITE_DEPLOY_REGION ??
    import.meta.env.VITE_REGION ??
    "unspecified";

  const commit =
    import.meta.env.VITE_COMMIT_SHA ??
    import.meta.env.VITE_GIT_COMMIT ??
    import.meta.env.VITE_GITHUB_SHA ??
    "local-dev";

  const contactEmail = "careers@theedgeacademy.club";

  // Line 1: brand + tagline (slim)
  const line1 = [
    {
      text: " The Edge Academy ",
      style:
        "background:#0b2239;color:#f1f6ff;font-weight:700;padding:4px 8px;border-radius:6px 0 0 6px;font-size:12px;letter-spacing:0.2px;",
    },
    {
      text: " — Building better tech leaders ",
      style:
        "background:#0b2239;color:#dce7ff;font-style:italic;padding:4px 8px;border-radius:0 6px 6px 0;font-size:12px;",
    },
  ];

  // Line 2: compact badges
  const line2 = [
    {
      text: ` Stage: ${stage} `,
      style:
        "background:#2563eb;color:#e8efff;font-weight:700;padding:3px 8px;border-radius:10px;font-size:11px;",
    },
    {
      text: ` Region: ${region} `,
      style:
        "background:#10b981;color:#0b1f14;font-weight:700;padding:3px 8px;border-radius:10px;margin-left:4px;font-size:11px;",
    },
    {
      text: ` Commit: ${commit} `,
      style:
        "background:#f97316;color:#0f172a;font-weight:700;padding:3px 8px;border-radius:10px;margin-left:4px;font-size:11px;",
    },
    {
      text: ` Careers: ${contactEmail} `,
      style:
        "background:#facc15;color:#0f172a;font-weight:800;padding:3px 8px;border-radius:10px;margin-left:4px;font-size:11px;",
    },
  ];

  log(line1.map((b) => `%c${b.text}`).join(""), ...line1.map((b) => b.style));
  log(line2.map((b) => `%c${b.text}`).join(""), ...line2.map((b) => b.style));
};
